/**
 * /collections/skincare 専用
 * リチュアル「テキスト付きアイコン」のスマホ版横スクロールに
 * ページネーションドットを付与する。
 *
 * 対象: collection.skincare.json のセクションキー ritual_scroll
 *       → #shopify-section-...__ritual_scroll
 * SP（〜749px）でのみ機能。要素が無ければ何もしない（自己ガード）。
 */
(function () {
  function init() {
    var section = document.querySelector('[id$="__ritual_scroll"]');
    if (!section) return;

    var list = section.querySelector('.c-image-with-icon__list');
    if (!list) return;

    var content = section.querySelector('.custom-section-content') || list.parentNode;

    var cards = Array.prototype.filter.call(list.children, function (el) {
      return el.nodeType === 1;
    });
    if (cards.length < 2) return;

    // 二重生成防止
    if (content.querySelector('.ritual-scroll__nav')) return;

    // ---- ドット ----
    var nav = document.createElement('div');
    nav.className = 'ritual-scroll__nav';

    var dots = cards.map(function (card, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ritual-scroll__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', i + 1 + '番目のアイテムへ');
      dot.addEventListener('click', function () {
        card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      nav.appendChild(dot);
      return dot;
    });
    list.insertAdjacentElement('afterend', nav);

    function activeIndex() {
      // list の可視左端を基準に各カード中心と viewport 中心を比較
      // （offsetLeft は offsetParent 依存でズレるため getBoundingClientRect を使用）
      var listLeft = list.getBoundingClientRect().left;
      var center = list.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (card, i) {
        var r = card.getBoundingClientRect();
        var cardCenter = r.left - listLeft + r.width / 2;
        var d = Math.abs(cardCenter - center);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      });
      return best;
    }

    function update() {
      var idx = activeIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    var ticking = false;
    list.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
        ticking = true;
      }
    });
    window.addEventListener('resize', update);

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
